export default __webpack_public_path__ + "static/media/mind.fe524802.jpg";